// extracted by mini-css-extract-plugin
export var metric = "style_metric__8Skts";